import React from 'react';
import styled from 'ui/styled';

export type ContainerProps = {
  background: string;
  hover: string;
  grow?: boolean;
};

export const Container = styled.button<ContainerProps>`
  background: ${({ background }) => background};
  font-family: var(--system-font);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: ${({ grow }) => (grow ? 'flex-start' : 'center')};
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  ${({ grow }) => (grow ? 'flex-grow: 1;' : '')}
  padding: 0;
  margin: 0;
  width: auto;
  min-width: 50px;
  height: 50px;
  
  &:hover, &:focus {
    background: ${({ hover }) => hover};
  }
  
  &:active {
    transform: scale(0.99);
  }
`;

export const Icon = styled.div`
  padding: 10px;
  display: flex;
`;

export const Text = styled.div`
  padding: 0 20px 0 10px;
  font: inherit;
  font-size: 16px;
`;

export type LoginButtonProps = ContainerProps & {
  text: string;
  icon: any;
  small: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export function BaseSmmLoginButton(props: LoginButtonProps) {
  const { text, icon, small } = props;

  return (
    <Container type="button" title={text} aria-label={text} {...props} grow={!small}>
      <Icon>{icon}</Icon>
      {text && !small ? <Text>{text}</Text> : null}
    </Container>
  );
}
